<template>
  <div class="text-left">
    <h3 class="mt-15 mb-0">
      {{ $t("title.thesisData") }}
    </h3>
    <h5>
      {{ $t("form.thesis.doctoral_program") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-combobox
          v-model="publication.thesis.doctoral_program"
          :label="$t('form.thesis.doctoral_program')"
          :items="doctoralPrograms"
          required
          outlined
          :rules="rules.char_max_150"
          :counter="150"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'thesis', 'doctoral_program')"
        ></v-combobox>
      </v-col>
    </v-row>
    <h5>
      {{ $t("label.dates") }}
    </h5>
    <v-row>
      <v-col cols="6" class="py-0">
        <v-menu
          v-model="menu_start_date"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          :disabled="disabledForm"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              outlined
              v-model="publication.thesis.start_date"
              :label="$t('form.thesis.start_date')"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              :rules="rules.fieldRequired"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="publication.thesis.start_date"
            @input="menu_start_date = false"
            :readonly="disabledForm"
            @change="$emit('handle-change', 'thesis', 'start_date')"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" class="py-0">
        <v-menu
          v-model="menu_deposit_date"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          :disabled="disabledForm"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              outlined
              v-model="publication.thesis.deposit_date"
              :label="$t('form.thesis.deposit_date')"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              :rules="rules.fieldRequired"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="publication.thesis.deposit_date"
            @input="menu_deposit_date = false"
            :readonly="disabledForm"
            @change="$emit('handle-change', 'thesis', 'deposit_date')"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.thesis.thesisLecture") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="12" md="6" class="py-0">
        <v-text-field
          v-model="publication.thesis.read_center"
          :label="$t('form.thesis.read_center')"
          required
          outlined
          :rules="rules.char_max_100"
          :counter="100"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'thesis', 'read_center')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <v-menu
          v-model="menu_lecture_date"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          :disabled="disabledForm"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              outlined
              v-model="publication.thesis.lecture_date"
              :label="$t('form.thesis.lecture_date')"
              prepend-inner-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="publication.thesis.lecture_date"
            @input="menu_lecture_date = false"
            :readonly="disabledForm"
            @change="$emit('handle-change', 'thesis', 'lecture_date')"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0">
        <v-combobox
          v-model="publication.thesis.grade"
          :label="$t('form.thesis.grade')"
          :items="gradeOptions"
          required
          outlined
          :rules="rules.char_max_40"
          :counter="40"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'thesis', 'grade')"
        ></v-combobox>
      </v-col>
    </v-row>
    <h5>
      {{ $t("form.thesis.international_phd") }}
    </h5>
    <v-row>
      <v-col class="py-0">
        <v-checkbox
          class="big"
          v-model="publication.thesis.international_phd"
          :label="$t('form.thesis.internationalPhdDetail')"
          :readonly="disabledForm"
          @change="$emit('handle-change', 'thesis', 'international_phd')"
        />
      </v-col>
    </v-row>
    <h5>{{ $t("form.thesis.directors") }}</h5>
    <SelectPeopleComboBox
      :items-selected="publication.thesis.directors"
      :disabled-form="disabledForm"
      @change="$emit('handle-change', 'thesis', 'directors')"
    />
    <h5>{{ $t("form.thesis.tutor") }}</h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-select
          :items="namePersons"
          item-text="name"
          item-value="id"
          v-model="publication.thesis.tutor"
          :readonly="disabledForm"
          :label="$t('form.thesis.tutor')"
          @change="$emit('handle-change', 'thesis', 'tutor')"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validationRules from "../../../mixins/validationRules";
import axios from "axios";
import SelectPeopleComboBox from "../../reusables/SelectPeopleComboBox";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  components: { SelectPeopleComboBox },
  mixins: [validationRules, publication_model],
  name: "ModifyCommunication",
  props: {
    disabledForm: Boolean,
    publication: Object
  },
  data: () => ({
    menu_start_date: false,
    menu_deposit_date: false,
    menu_lecture_date: false,
  }),

  created() {
    this.getNamePersons();
    this.getGradeOptions();
    this.getDoctoralProgramOptions();
  },

};
</script>

<style scoped></style>
